import { render, staticRenderFns } from "./FollowUpHistoryModal.vue?vue&type=template&id=582a8442&scoped=true"
import script from "./FollowUpHistoryModal.vue?vue&type=script&lang=js"
export * from "./FollowUpHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./FollowUpHistoryModal.vue?vue&type=style&index=0&id=582a8442&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582a8442",
  null
  
)

export default component.exports